import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    delay: {
      type: Number,
      default: 150
    }
  }

  connect () {
    this.debounceTimer = null
  }

  submit (event) {
    const appliedFilterToRemove = event.target.parentElement.parentElement
    if (appliedFilterToRemove) {
      appliedFilterToRemove.remove()
    }
    // A filter with a controller default sends its cleared value ("all"): without the param, the default comes back.
    const { name, clearedValue } = event.params
    if (name && clearedValue) {
      this.element.appendChild(this.hiddenInput(name, clearedValue))
    }
    clearTimeout(this.debounceTimer)
    this.debounceTimer = setTimeout(() => this.element.requestSubmit(), this.delayValue)
  }

  hiddenInput (name, value) {
    const input = document.createElement("input")
    input.type = "hidden"
    input.name = name
    input.value = value
    return input
  }
}
